

import Dermatologist from '../src/assets/images/specialitymenu/Dermatologist.svg'
import Gastroenterologist from '../src/assets/images/specialitymenu/Gastroenterologist.svg'
import General_physician from '../src/assets/images/specialitymenu/General_physician.svg'
import Gynecologist from '../src/assets/images/specialitymenu/Gynecologist.svg'
import Neurologist from '../src/assets/images/specialitymenu/Neurologist.svg'
import Pediatricians from '../src/assets/images/specialitymenu/Pediatricians.svg'

import doc1 from '../src/assets/images/Doctors/2.png'
import doc2 from '../src/assets/images/Doctors/3.png'
// doc3 import removed (doctor entry deleted)
import doc4 from '../src/assets/images/Doctors/8.png'
import doc5 from '../src/assets/images/Doctors/9.png'
import doc6 from '../src/assets/images/Doctors/1.png'
// doc7 import removed (doctor entry deleted)
import doc8 from '../src/assets/images/Doctors/6.png'
import doc9 from '../src/assets/images/Doctors/7.png'
import doc10 from '../src/assets/images/Doctors/10.png'
import doc11 from '../src/assets/images/Doctors/11.png'
import doc12 from '../src/assets/images/Doctors/12.png'
// doc13 import removed (doctor entry deleted)
// doc14 import removed (doctor entry deleted)
import doc15 from '../src/assets/images/Doctors/15.png'
// doc16 import removed (doctor entry deleted)
import doc17 from '../src/assets/images/Doctors/17.png'
// doc18 import removed (doctor entry deleted)
import doc19 from '../src/assets/images/Doctors/19.png'


export const specialityData = [
    {
        speciality: 'General physician',
        image: General_physician
    },
    {
        speciality: 'Gynecologist',
        image: Gynecologist
    },
    {
        speciality: 'Dermatologist',
        image: Dermatologist
    },
    {
        speciality: 'Pediatricians',
        image: Pediatricians
    },
    {
        speciality: 'Neurologist',
        image: Neurologist
    },
    {
        speciality: 'Gastroenterologist',
        image: Gastroenterologist
    },
]

// doctors info

export const doctors = [
    {
        _id: 'doc1',
        name: 'Dr. P. Venkateswarlu',
        image: doc1,
        speciality: 'Consultant General Surgeon',
        about: 'Dr. P. Venkateswarlu is a highly experienced Consultant General Surgeon with a strong commitment to delivering comprehensive and patient-centered medical care. His clinical approach emphasizes preventive medicine, early and accurate diagnosis, and effective treatment strategies to ensure the best possible outcomes for his patients.'
    },
    {
        _id: 'doc2',
        name: 'Dr. Satya Raju Pappala',
        image: doc2,
        speciality: 'Consultant Physician & Diabetologist (MBBS, MD)',
        degree: 'MBBS',
        about: 'Dr. Satya Raju Pappala is an experienced Consultant Physician & Diabetologist (MBBS, MD) committed to delivering comprehensive and patient-focused medical care. His clinical practice emphasizes preventive medicine, early diagnosis, and effective management of chronic and acute medical conditions, with a special focus on diabetes care.'
    },
    /* Dr. Sarah Patel entry removed */
    {
        _id: 'doc4',
        name: 'Dr. B. Lucy Cordiliya ',
        image: doc4,
        speciality: 'Consultant General Physician',
        degree: 'MBBS',
        about: 'Dr. B. Lucy Cordiliya is an experienced Consultant General Physician dedicated to providing comprehensive and patient-centered medical care. Her clinical approach focuses on preventive healthcare, accurate diagnosis, and effective treatment of a wide range of acute and chronic medical conditions.'
    },
    {
        _id: 'doc5',
        name: 'Dr. Joshna',
        image: doc5,
        speciality: 'Dental Surgeon',
        degree: 'BDS',
        about: 'Dr. Joshna is an experienced Dental Surgeon dedicated to providing comprehensive and patient-centered dental care. Her clinical approach focuses on preventive oral healthcare, accurate diagnosis, and effective treatment for a wide range of dental conditions.'
    },
    {
        _id: 'doc6',
        name: 'Dr. P. Sudha Malini',
        image: doc6,
        speciality: 'Consultant Obstetrician & Gynaecologist (MS, DGO)',
        degree: 'MBBS',
        about: 'Dr. P. Sudha Malini is an experienced Consultant Obstetrician & Gynaecologist (MS, DGO) dedicated to providing comprehensive and compassionate care for women at every stage of life. Her clinical focus includes preventive care, accurate diagnosis, and effective treatment for a wide range of obstetric and gynaecological conditions.'
    },
    /* Dr. Christopher Davis entry removed */
    {
        _id: 'doc9',
        name: 'Dr. Shaik Haji Mastan C',
        image: doc9,
        speciality: 'Consultant Pediatrician & Neonatologist (MBBS, DCH, DNB)',
        degree: 'MBBS',
        about: 'Dr. Shaik Haji Mastan is a highly experienced Consultant Pediatrician & Neonatologist (MBBS, DCH, DNB) dedicated to providing comprehensive medical care for infants, children, and newborns. His clinical approach focuses on preventive child healthcare, early diagnosis, and effective treatment, ensuring healthy growth and development from birth through adolescence.'
    },
    {
        _id: 'doc10',
        name: 'Dr. Mala Saranathan',
        image: doc10,
        speciality: 'Consultant Dermatologist (MBBS, DDVL)',
        degree: 'MBBS',
        about: 'Dr. Mala Saranathan is an experienced Consultant Dermatologist (MBBS, DDVL) committed to providing comprehensive care for skin, hair, and nail conditions. She focuses on accurate diagnosis, personalized treatment plans, and preventive dermatological care to help patients achieve and maintain healthy skin.'
    },
    {
        _id: 'doc11',
        name: 'Dr. G. Vijay Sainath Reddy',
        image: doc11,
        speciality: 'Consultant General Surgeon & Cancer Specialist (MBBS, MS, DNB, MCh)',
        degree: 'MBBS',
        about: 'Dr. G. Vijay Sainath Reddy is a highly qualified Consultant General Surgeon and Cancer Specialist (MBBS, MS, DNB, MCh) with extensive experience in providing comprehensive surgical and oncological care. He is committed to early diagnosis, precise surgical intervention, and effective treatment planning to achieve the best possible outcomes for his patients.'
    },
    {
        _id: 'doc12',
        name: 'Dr. Kiran K Nandivada V.S',
        image: doc12,
        speciality: 'Senior Consultant Orthopaedic Surgeon',
        degree: 'MBBS',
        about: 'Dr. Kiran K. Nandivada V.S is a highly experienced Senior Consultant Orthopaedic Surgeon dedicated to providing comprehensive and advanced orthopaedic care. He focuses on accurate diagnosis, effective treatment planning, and long-term patient recovery, ensuring the highest standards of medical excellence.'
    },
    /* Dr. Chloe Evans & Dr. Ryan Martinez entries removed */
    {
        _id: 'doc15',
        name: 'Dr G Raja Sekharam',
        image: doc15,
        speciality: 'Consultant Pulmonary Medicine',
        degree: 'MBBS, MD',
        about: 'Dr. G Raja Sekharam is an experienced Consultant in Pulmonary Medicine, dedicated to providing comprehensive care for respiratory and sleep disorders. His clinical approach focuses on accurate diagnosis, personalized treatment plans, and improving lung health and overall quality of life for his patients.'
    },
    /* Dr. James Wilson entry removed */
    {
        _id: 'doc17',
        name: 'Dr. B. Nageswara Rao',
        image: doc17,
        speciality: 'Consultant Physician & Diabetologist (MBBS, DNB)',
        degree: 'MBBS, MD',
        about: 'Dr. B. Nageswara Rao is an experienced Consultant Physician & Diabetologist (MBBS, DNB) dedicated to providing comprehensive and patient-centered medical care. His clinical approach focuses on preventive healthcare, early diagnosis, and effective management of acute and chronic medical conditions, with special expertise in diabetes care.'
    },
    /* Dr. Indravathi entry removed */
    {
        _id: 'doc19',
        name: 'Dr. Bhavika Soorada',
        image: doc19,
        speciality: 'Consultant Laparoscopic & Cosmetic Gynaecologist',
        degree: 'MBBS',
        about: 'Dr. Bhavika Soorada is an experienced Consultant Laparoscopic & Cosmetic Gynaecologist dedicated to providing advanced, safe, and patient-focused women’s healthcare. She specializes in minimally invasive laparoscopic procedures and cosmetic gynaecology, with an emphasis on precision, safety, and optimal outcomes.'
    },
]